<template>
  <v-dialog v-model="dialog" persistent max-width="900">
    <template v-if="!hideActivator" v-slot:activator="{ on }">
      <v-tooltip bottom>
        <template v-slot:activator="tooltip">
          <div
            v-bind="tooltip.attrs"
            v-on="!edit && possuiPropostaEmProcessamento && tooltip.on"
          >
            <v-btn
              v-on="on"
              color="primary"
              class="mr-3"
              :disabled="!edit && possuiPropostaEmProcessamento"
            >
              <slot name="title"></slot>
            </v-btn>
          </div>
        </template>
        Não é possível gerar nova proposta, devido à existência de uma
        em processamento.
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="fechar" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text style="max-height: 60vh; overflow-y: auto">
        <v-row>
          <v-col>
            <h3>
              Para {{ !edit ? "gerar" : "editar" }} uma proposta, escolha um
              pacote.
            </h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <CombosComboboxMT
              :filter="atualCombo"
              @onChange="trocaPacote"
            ></CombosComboboxMT>
          </v-col>
        </v-row>
        <TabelaValores
          :payload="{ ...payload, solucoesFaixasDTO: selectedSolutions }"
          :faixa="faixa"
          :combos="combos"
          :atualCombo="atualCombo"
          :onlyTotal="true"
          :solucoesPacote="solucoesPacote"
          ref="tabela"
        ></TabelaValores>
        <template>
          <v-row v-if="atualCombo && atualCombo.combo.solucaoIds">
            <v-col
              ><ComboboxGroupSolution
                :filter="{
                  grupoSolucaoId: atualGrupoSolucao,
                }"
                :mostrarTipo="true"
                :title="'Eixos Adicionais'"
                @changeGroupSolution="changeGroupSolution"
                :maximoEixos="maximoEixos"
              ></ComboboxGroupSolution>
            </v-col>
            <v-col v-if="atualGrupoSolucao">
              <ComboboxSolution
                :filter="{
                  solutions: atualSolutions,
                  solucaoId: selectedSolutions,
                }"
                multiple
                @changeSolution="changeSolution"
                @createExtra="openCriarSolucaoExtra"
                returnObject
                :title="'Soluções Adicionais'"
                :solutionIds="[]"
                :removeClearable="true"
                :showCreateExtra="true"
                :disableCreateExtra="!atualGrupoSolucao"
              ></ComboboxSolution>
              <ModalInsertSolucaoExtra
                ref="modalSolucaoExtra"
                :fixedGrupoSolucaoId="atualGrupoSolucao"
                :disableGroupSelection="true"
                :hideActivator="true"
                @created="handleSolucaoExtraCreated"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-data-table
                :headers="headers"
                :items="selectedSolutions"
                class="elevation-1 w-100 proposta"
                hide-default-footer
                disable-pagination
                fixed-header
              >
                <template v-slot:item.nome="{ item }">
                  <div>
                    <div>
                      {{ item.nome }}
                    </div>
                    <div
                      style="
                        color: #898686;
                        font-size: 12px;
                        font-style: italic;
                      "
                    >
                      {{
                        solucoesPacote.includes(item.solucaoId + "")
                          ? "(Solução do Pacote) "
                          : item.municipioPropostaSolucoesExtrasId
                          ? "(Solução extra) "
                          : ""
                      }}
                    </div>
                  </div>
                </template>
                <template v-slot:item.acoes="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="tooltip">
                      <div
                        v-bind="tooltip.attrs"
                        v-on="
                          !podeExcluirSolucao && item.disabled && tooltip.on
                        "
                      >
                        <v-btn
                          outlined
                          color="error"
                          class="mr-3"
                          @click="deleteProposta(item)"
                          :disabled="item.disabled"
                        >
                          <v-icon>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    Somente usuários com permissão podem excluir soluções de um
                    pacote.
                  </v-tooltip>
                </template>

                <template slot="no-data">
                  <span> Nenhum eixo adicionado </span>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="fechar">Fechar</v-btn>
        <v-btn color="info" outlined text @click="onConfirm">
          <slot name="title"></slot
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ComboboxGroupSolution from "@/modules/group-solution/components/Combobox.vue";
import ComboboxSolution from "@/modules/solution/components/Combobox.vue";
import { solutionAPI } from "@/modules/solution/components/SolutionAPI";
import { propostaApi } from "@/apis/proposta";
import { municipioPropostaSolucaoExtraApi } from "@/apis/proposta";
import { statusPropostasEnum } from "@/modules/city/components/propostas/statusPropostasEnum.js";
import moment from "moment";
import TabelaValores from "@/modules/city/components/propostas/mt/TabelaValoresMT.vue";
import PacotesEnum from "@/modules/city/components/propostas/ma/pacotesEnum";
import CombosComboboxMT from "./CombosComboboxMT.vue";
import ModalInsertSolucaoExtra from "@/modules/city/components/propostas/solucoesExtras/ModalInsert.vue";
export default {
  name: "ModalNovaPropostaMA",
  components: {
    ComboboxGroupSolution,
    ComboboxSolution,
    TabelaValores,
    CombosComboboxMT,
    ModalInsertSolucaoExtra,
  },
  props: {
    payload: { type: Object, required: true },
    edit: { type: Object, default: () => {} },
    possuiPropostaEmProcessamento: { type: Boolean, default: false },
    hideActivator: { type: Boolean, default: false },
    combos: {
      type: Array,
      default: () => [],
    },
    faixa: { type: Object, default: null },
    solucoesExtras: {
      type: Array,
      default: () => [],
    },
    allSolutions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters(["isFullAdmin", "city", "user", "config", "groupsConfig"]),
    podeExcluirSolucao() {
      return (
        this.isFullAdmin ||
        (this.config.podeRetirarSolucaoPropostaPacote &&
          this.groupsConfig.podeRetirarSolucaoPropostaPacote)
      );
    },
    faixaSubsidioPreium() {
      return (this.atualCombo && this.atualCombo.combo.subsidio) || 0;
    },
    faixaSubsidio() {
      return (this.atualCombo && this.atualCombo.combo.subsidio) || 0;
    },
    eixosEscolhidos() {
      let a = [];

      if (this.selectedSolutions && this.selectedSolutions.length > 0)
        a = this.selectedSolutions.reduce((acc, item) => {
          if (
            !acc.some(
              (obj) => obj && item && obj.grupoSolucaoId === item.grupoSolucaoId
            )
          ) {
            acc.push(item);
          }
          return acc;
        }, []);

      return a;
    },
    maximoEixos() {
      //o máximo de eixos são 5, idependentes da solução

      return this.eixosEscolhidos.map((val) => val.grupoSolucaoId);
    },
    pacoteAtual() {
      let pacote = "Nenhum Pacote";

      if (this.eixosEscolhidos && this.eixosEscolhidos.length) {
        const qtdNegocios = this.eixosEscolhidos.filter((item) => {
          return item.grupoSolucao.tipo == PacotesEnum.negocios;
        });
        const qtdEstrategico = this.eixosEscolhidos.filter(
          (item) => item.grupoSolucao.tipo == PacotesEnum.estrategico
        );
        if (qtdNegocios.length == 2 && qtdEstrategico.length == 1)
          pacote = "Pacote Essencial";
        else if (qtdNegocios.length == 2 && qtdEstrategico.length == 2)
          pacote = "Pacote Premium";
        else if (qtdNegocios.length == 2 && qtdEstrategico.length == 3)
          pacote = "Pacote Ultimate";
      }

      return pacote;
    },
  },
  watch: {
    dialog(val) {
      if (val && !!this.edit) {
        const comboAtual = this.combos.find(
          (item) => item.municipioPropostaCombosId == this.edit.comboId
        );
        this.trocaPacote(comboAtual);
        this.loadSolutions();
      }
    },
    solucoesExtras: {
      handler(val) {
        this.solucoesExtrasLocal = val || [];
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      dialog: false,
      atualGrupoSolucao: null,
      atualSolutions: [],
      atualCombo: { combo: {} },
      solutions: [],
      pacotesEnum: PacotesEnum,
      selectedSolutions: [],
      solucoesPacote: [],
      novaProposta: { groupSolution: [] },
      solucoesExtrasLocal: [],
      pendingExtraSelectionId: null,
      headersValores: [
        { text: "", value: "combo", sortable: false },
        {
          text: "Investimento Total",
          value: "investimentoTotal",
          sortable: false,
        },
        {
          text: "Contrapartida Sebrae",
          value: "contrapartidaSebrae",
          sortable: false,
        },
        {
          text: "Investimento Municipal",
          value: "investimentoMunicipal",
          sortable: false,
        },
      ],
      headers: [
        { text: "Grupo", value: "grupoSolucao.nome", align: "center" },
        { text: "Solução", value: "nome", align: "center" },
        { text: "Ações", value: "acoes", align: "center" },
      ],
    };
  },

  methods: {
    ...mapActions(["setLoading"]),
    open() {
      this.dialog = true;
    },
    async refreshSolucoesExtras() {
      try {
        const resp = await municipioPropostaSolucaoExtraApi.listByMunicipio(
          this.$route.params.id
        );
        this.solucoesExtrasLocal = resp.data;
        if (this.atualGrupoSolucao) {
          await this.loadSolutionsByGroup(this.atualGrupoSolucao);
        }
        if (this.pendingExtraSelectionId) {
          const novaSolucao = this.solucoesExtrasLocal.find(
            (item) =>
              item.municipioPropostaSolucoesExtrasId ===
              this.pendingExtraSelectionId
          );
          if (novaSolucao) {
            const jaSelecionada = this.selectedSolutions.some(
              (item) =>
                item.municipioPropostaSolucoesExtrasId ===
                novaSolucao.municipioPropostaSolucoesExtrasId
            );
            if (!jaSelecionada) {
              this.selectedSolutions = [...this.selectedSolutions, novaSolucao];
            }
          }
          this.pendingExtraSelectionId = null;
        }
      } catch (error) {
        console.log("Erro ao atualizar soluções extras", error);
      }
    },
    valorSolucaoContrapartidaSebrae(preco) {
      const valorComSubsidio = preco * (this.faixaSubsidio / 100);

      return valorComSubsidio;
    },

    valorSolucaoInvestimentoMunicipio(preco) {
      const valorComSubsidio = preco * ((100 - this.faixaSubsidio) / 100);
      return valorComSubsidio;
    },
    trocaPacote(e) {
      if (!e) {
        this.atualCombo = { combo: {} };
        this.selectedSolutions = [];
        return;
      }
      this.atualCombo.combo = e;
      const solucoesId = e ? e.solucaoIds.split(",") : [];

      this.allSolutions = this.addPreco(this.allSolutions, []);

      this.selectedSolutions = this.allSolutions;

      this.selectedSolutions = this.selectedSolutions
        .filter((val) => solucoesId.includes(val.solucaoId + ""))
        .map((item) => ({
          ...item,
          disabled: !this.podeExcluirSolucao ? true : false,
        }));

      this.solucoesPacote = solucoesId;
    },
    duplicar(val) {
      const qd = this.selectedSolutions.filter(
        (item) => item.solucaoId === val.solucaoId
      ).length;

      this.selectedSolutions.push({
        ...val,
        nome: `${val.nome} ${qd + 1}`,
      });
    },
    onConfirm() {
      this.setLoading(true);
      var proposta = {
        comboId: this.atualCombo
          ? this.atualCombo.combo.municipioPropostaCombosId
          : null,
        municipioId: this.$route.params.id,
        usuarioCriacao: this.user.usuarioId,
        valorTotal: this.$refs.tabela && this.$refs.tabela.getValorTotal,
        status: statusPropostasEnum.emProcessamento,
        municipioPropostaGrupoSolucaoDTO: this.selectedSolutions.map(
          (item) => ({
            idSolucao: item.solucaoId,
            idGrupoSolucao:
              (item.grupoSolucao && item.grupoSolucao.grupoSolucaoId) ||
              item.grupoSolucaoId,
            solucaoExtraId: item.municipioPropostaSolucoesExtrasId,
            valorInvestimentoMunicipio: item.valorInvestimentoMunicipio || 0,
            valorContrapartidaSebrae: item.valorContrapartidaSebrae || 0,
            valorTotal: item.precoFaixa || 0,
          })
        ),
        contrapartidaSebrae:
          this.$refs.tabela && this.$refs.tabela.getValorContrapartidaSebrae,
        investimentoMunicipio:
          this.$refs.tabela && this.$refs.tabela.getValorInvestimentoMunicipal,
      };
      propostaApi
        .gerarProposta(proposta)
        .then((data) => {
          const novaPropostaId = data.headers?.["x-municipio-proposta-id"];
          this.fazerDownloadRelatorio(
            data.data,
            `Proposta - ${this.city}`,
            novaPropostaId
          );
        })
        .catch((err) => {
          this.$notification.error("Erro ao gerar Proposta");
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },
    async registrarEdicaoProposta(item, novaPropostaId) {
      let propostaId = novaPropostaId;

      if (!propostaId) {
        try {
          const propostas = await propostaApi.getPropostasPorMunicipioId(
            this.$route.params.id
          );
          const propostasOrdenadas = (propostas.data || [])
            .map((proposta) => proposta.municipioPropostaId)
            .filter((id) => id !== item.municipioPropostaId);
          propostaId = propostasOrdenadas.length
            ? Math.max(...propostasOrdenadas)
            : null;
        } catch (error) {
          console.log("Erro ao obter proposta gerada", error);
        }
      }

      if (!propostaId) {
        this.setLoading(false);
        return;
      }

      item.status = statusPropostasEnum.editada;
      item.justificativaRecusa = `Substituída pela proposta número: ${propostaId}`;
      propostaApi
        .update(item)
        .then(() => {
          this.$emit("onLoad");
          this.dialog = false;
        })
        .catch((err) => {
          console.log("Erro no cancelar ", err);
          this.setLoading(false);
        });
    },
    deleteProposta(item) {
      this.selectedSolutions = this.selectedSolutions.filter(
        (val) => item !== val
      );
    },
    changeSolution(solutions) {
      this.selectedSolutions = solutions.reverse();
    },
    loadSolutions() {
      solutionAPI.list({}).then((res) => {
        this.solutions = res.data;

        this.selectedSolutions = this.edit.municipioPropostaGrupoSolucao
          .map((id) => {
            return {
              ...this.solutions.find((item) => item.solucaoId === id.idSolucao),
              valorContrapartidaSebrae: id.valorContrapartidaSebrae,
              valorInvestimentoMunicipio: id.valorInvestimentoMunicipio,
            };
          })
          .filter((i) => i && i.solucaoId);

        const solucoesExtra = this.edit.municipioPropostaGrupoSolucao
          .map((item) =>
            this.solucoesExtrasLocal.find(
              (v) => item.solucaoExtraId == v.municipioPropostaSolucoesExtrasId
            )
          )
          .filter((i) => i && i.municipioPropostaSolucoesExtrasId);

        this.selectedSolutions = [...this.selectedSolutions, ...solucoesExtra];

        this.allSolutions = this.addPreco(
          this.selectedSolutions,
          solucoesExtra
        );
        this.selectedSolutions = this.allSolutions;
      });
    },
    addPreco(data, solucoesExtras) {
      const solucoesPrecos =
        (this.faixa &&
          this.faixa.solucoesFaixasDTO &&
          this.faixa.solucoesFaixasDTO.length &&
          this.faixa.solucoesFaixasDTO) ||
        [];

      let solucoesPreco = [];

      solucoesPreco = data.filter((val) =>
        solucoesPrecos.some((item) => item.solucaoId == val.solucaoId)
      );

      solucoesPreco = [...solucoesPreco, ...solucoesExtras];

      if (solucoesPreco && solucoesPreco.length) {
        solucoesPreco = solucoesPreco.map((val) => {
          const solucaoAtual = solucoesPrecos.find(
            (a) => a.solucaoId == val.solucaoId
          );

          return {
            ...val,
            precoFaixa:
              (solucaoAtual && solucaoAtual.preco) || val.preco || undefined,
            custoFaixa:
              (solucaoAtual && solucaoAtual.custo) || val.custo || undefined,
            solucaoFaixaid:
              (solucaoAtual && solucaoAtual.solucaoFaixaid) || undefined,
            valorInvestimentoMunicipio: this.valorSolucaoInvestimentoMunicipio(
              (solucaoAtual && solucaoAtual.preco) || val.preco || 0
            ),
            valorContrapartidaSebrae: this.valorSolucaoContrapartidaSebrae(
              (solucaoAtual && solucaoAtual.preco) || val.preco || 0
            ),
          };
        });
      }

      return solucoesPreco;
    },
    async loadSolutionsByGroup(val) {
      try {
        this.atualSolutions = [];
        const data = await solutionAPI.getSolutions([val]);
        let disabledPacoteSolutions = data.data;

        disabledPacoteSolutions = data.data.map((item) => {
          if (this.solucoesPacote.includes(item.solucaoId + ""))
            return {
              ...item,
              disabled: !this.podeExcluirSolucao ? true : false,
            };

          return item;
        });

        let solucoesExtrasGrupo = [];

        if (this.solucoesExtrasLocal && this.solucoesExtrasLocal.length > 0) {
          solucoesExtrasGrupo = this.solucoesExtrasLocal.filter(
            (item) => val == item.grupoSolucaoId
          );
        }

        this.atualSolutions = this.addPreco(
          disabledPacoteSolutions,
          solucoesExtrasGrupo
        );
      } catch (error) {
        console.log("🚀 ~ loadSolutionsByGroup ~ error:", error);
      }
    },
    fazerDownloadRelatorio(file, nomeArquivo, novaPropostaId) {
      var fileURL = window.URL.createObjectURL(new Blob([file]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute(
        "download",
        `${nomeArquivo} - ${moment().format("DD.MM.YYYY.HH.mm")}.pdf`
      );

      document.body.appendChild(fileLink);
      fileLink.click();

      if (this.edit) {
        this.registrarEdicaoProposta(this.edit, novaPropostaId);
      } else {
        this.$notification.success("Proposta gerada com sucesso!");

        this.$emit("onLoad");
        this.dialog = false;
        this.setLoading(false);
      }
    },
    changeGroupSolution(grupoSolucaoId) {
      this.atualGrupoSolucao = grupoSolucaoId;
      this.loadSolutionsByGroup(this.atualGrupoSolucao);
    },
    openCriarSolucaoExtra() {
      if (!this.atualGrupoSolucao) {
        this.$notification.error("Selecione um eixo antes de criar a solução.");
        return;
      }
      this.$refs.modalSolucaoExtra.openWithGrupo(this.atualGrupoSolucao);
    },
    handleSolucaoExtraCreated(novaSolucao) {
      if (
        novaSolucao &&
        novaSolucao.municipioPropostaSolucoesExtrasId &&
        novaSolucao.grupoSolucaoId
      ) {
        this.pendingExtraSelectionId =
          novaSolucao.municipioPropostaSolucoesExtrasId;
      }
      this.refreshSolucoesExtras();
      this.$emit("refreshSolucoesExtras");
    },
    fechar() {
      if (!this.edit) {
        this.selectedSolutions = [];
        this.atualGrupoSolucao = null;
      }

      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.comboEssencial {
  color: var(--corPrimaria);
  cursor: pointer;
}
.combo {
  .header {
    background: black;
    margin-left: -28px;
    width: 135%;
    text-align: center;
    margin-top: -16px;
    margin-bottom: 5px;
  }
}
</style>
